var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "XMLID_31_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-executable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,14v1h3v2H2v1h4v2H2H0v-2v-1v-2v-1v-2h2h4v2H2z M20,14v-2h-4h-2v2v1v2v1v2h2h4v-2h-4v-1h3v-2h-3v-1H20z M13.6,20L11,15.8 l2.4-3.8h-2.2l-1.3,2.1L8.6,12H6.4l2.4,3.8L6.2,20h2.2l1.5-2.4l1.5,2.4H13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,0H4v8h2V2h10v6h6v14H5v2h19V5.6L18.4,0z M18,2.4L21.6,6H18V2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExe);
export default __webpack_public_path__ + "static/media/exe.6ad7277cb1ba0f7e1d96f13f8fa612c0.svg";
export { ForwardRef as ReactComponent };